module.exports = function translation (languages) {
  return function translate (item, key, params) {
    const locale = languages[item.language]
    if (!locale) return `[${key}]`

    let s = locale[key] || `[${key}]`
    if (params && typeof params.count === 'number') {
      if (locale[`${key}_${params.count}`]) {
        s = locale[`${key}_${params.count}`]
      } else if (params.count !== 1 && locale[`${key}_plural`]) {
        s = locale[`${key}_plural`]
      }
    }

    for (const param of Object.keys(params || {})) s = s.replace(`{{${param}}}`, params[param])
    return s
  }
}
